import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { AuthUser } from 'src/app/core/models/auth/auth.models';
import { hasRole } from 'src/app/shared/utils/role.util';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false
})
export class SidebarComponent {
  readonly user$: Observable<AuthUser | null> = this.auth.user$;

  constructor(private auth: AuthService) {}

  dashboardLink(user: AuthUser | null): string {
    const roles = user?.roles ?? [];
    return hasRole(roles, 'parceiro', 'company')
      ? '/parceiro/dashboard'
      : '/admin/dashboard';
  }

  canAccess(user: AuthUser | null, moduleName: string): boolean {
    if (!user) return false;
    const roles = user.roles ?? [];

    // Master e Admin sempre veem tudo
    if (hasRole(roles, 'master', 'admin')) return true;

    const mods = user.modules ?? [];

    // Parceiro e company só acessam o Dashboard
    if (hasRole(roles, 'parceiro', 'company')) {
      return moduleName === 'Dashboard';
    }

    // Gerente e colaborador veem apenas os módulos específicos
    if (hasRole(roles, 'gerente', 'colaborador')) {
      return mods.includes(moduleName);
    }

    // Fallback para usuários comuns
    return false;
  }
}
